import { render, staticRenderFns } from "./DotList.vue?vue&type=template&id=19d546ed&scoped=true"
import script from "./DotList.vue?vue&type=script&lang=js"
export * from "./DotList.vue?vue&type=script&lang=js"
import style0 from "./DotList.vue?vue&type=style&index=0&id=19d546ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d546ed",
  null
  
)

export default component.exports